import * as React from "react";
import type { SVGProps } from "react";
const SvgEmergencyPhone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#emergency-phone_svg__a)">
      <path d="M19 1h-2v10h2z" />
      <path d="m14.167 2.631-1 1.732 8.66 5 1-1.732z" />
      <path d="m21.805 2.646-8.66 4.999.999 1.732 8.661-4.999z" />
      <path d="M17.88 23A18 18 0 0 1 1 6.18 3.14 3.14 0 0 1 4.12 3h4.23a1 1 0 0 1 .93.63l2.12 5.29a1 1 0 0 1-.41 1.23l-1.83 1.1a10.8 10.8 0 0 0 3.59 3.59l1.1-1.83a1 1 0 0 1 1.23-.41l5.29 2.12a1 1 0 0 1 .63.93v4.23A3.12 3.12 0 0 1 17.88 23M4.12 5A1.12 1.12 0 0 0 3 6.12 16 16 0 0 0 17.94 21 1.11 1.11 0 0 0 19 19.88v-3.56l-3.88-1.55L14 16.69a1 1 0 0 1-1.3.38 12.66 12.66 0 0 1-5.74-5.74 1 1 0 0 1 .38-1.3l1.92-1.15L7.68 5z" />
    </g>
    <defs>
      <clipPath id="emergency-phone_svg__a">
        <path fill="#fff" d="M1 1h21.83v22H1z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgEmergencyPhone;
